module.exports = __webpack_public_path__ + "08_hair_gold.82fb52ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/08_hair_gold.png
// module id = B8M3
// module chunks = 0